import i18n from '../i18n';
import type { SportContext } from './sportContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const tt = (key: string, opts?: Record<string, unknown>) => (i18n as any).t(key, opts);
const t = (key: string, opts?: Record<string, unknown>) => tt(`onboarding:${key}`, opts);

export function getStudentTour(ctx: SportContext) {
  const c = ctx.copy;
  return [
    {
      target: '[data-onboarding="dashboard-main"]',
      title: tt('nav:home'),
      content: c.studentTourDashboard,
      placement: 'bottom',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-balance"]',
      title: tt('nav:myBalance'),
      content: c.studentTourBalance,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-schedule"]',
      title: tt('nav:schedule'),
      content: c.studentTourSchedule,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-apply"]',
      title: t('tourApplyTitle'),
      content: t('tourApplyContent'),
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-rental"]',
      title: tt('nav:rental'),
      content: c.studentTourRental,
      placement: 'right',
      skipBeacon: true
    },
    {
      target: '[data-onboarding="nav-customize"]',
      title: t('tourCustomizeMenuTitle'),
      content: t('tourCustomizeMenuContent'),
      placement: 'right',
      skipBeacon: true
    }
  ];
}

export function getStudentChecklist(ctx: SportContext) {
  return [
    {
      key: 'join_school',
      label: t('studentChecklistJoinSchool'),
      description: t('studentChecklistJoinDesc'),
      route: '/apply'
    },
    {
      key: 'view_balance',
      label: t('studentChecklistViewBalance'),
      description: t('studentChecklistViewBalanceDesc', {
        subscription: ctx.subscription || t('subscription')
      }),
      route: '/my-balance'
    },
    {
      key: 'view_schedule',
      label: t('studentChecklistViewSchedule'),
      description: t('studentChecklistViewScheduleDesc'),
      route: '/schedule'
    },
    {
      key: 'confirm_attendance',
      label: t('studentChecklistConfirmAttendance'),
      description: t('studentChecklistConfirmDesc'),
      route: '/attendance'
    }
  ];
}

export function getStudentWelcome() {
  return {
    subtitle: t('welcomeMemberSubtitle'),
    startLabel: t('welcomeStartTour')
  };
}

export const STUDENT_WELCOME = getStudentWelcome();

export function getStudentChecklistUi() {
  return {
    title: t('checklistMemberTitle'),
    doneTitle: t('checklistMemberDone'),
    doneMessage: t('studentChecklistDoneMessage'),
    doneButton: t('studentChecklistDoneButton'),
    doneRoute: '/schedule'
  };
}

